
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorSeccion } from './controlador';
    import { Cliente } from '@/__env/lib/Clientes';
    import { Wait } from '@/__env/ext';
    import { Envio } from '@/__env/lib/Ventas/Envios';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Item } from '@lib/Ventas/Pedidos/Item';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorSeccion;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Envio() { return this.Controlador.Pedido.Envio; }
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        Estado: 'ok' | 'cargando' | 'error' = 'ok';
        @Watch( 'Estado' )
        onEstado()
        {
            this.$emit( 'estado', this.Estado );
        }

        public Articulo: Articulo = null;
        @Watch( 'Articulo' )
        async onArticulo()
        {
            if ( this.Articulo )
            {
                let item = new Item();
                item.Codigo = this.Articulo.Id;
                item.Articulo = await Articulo.create( this.Articulo.Id);
                this.Pedido.Items.push( item );

                console.log( this.Pedido.Items );

                this.Refrescar();
                this.$nextTick( () =>
                {
                    this.Articulo = null;
                })

            }

            //this.$emit( 'estado', this.Estado );
        }

        public HayCambios: boolean = false;
        async mounted()
        {

        }

        async Iniciar()
        {
            this.Estado = 'cargando';

            await Wait( 100 );

            this.Estado = 'ok';
            this.HayCambios = false;

            this.$nextTick( () =>
            {
                //document.getElementById( 'primer-input' ).getElementsByTagName( 'input' )[0].focus();
            } );
        }

        async Guardar()
        {
            this.Estado = 'cargando';
            let e = await this.Envio.save();
            if ( e )
            {
                this.Estado = 'ok';
                this.Pedido.Envio = this.Envio;
                this.Controlador.Vista.Modo = 'resumen';
                this.$EventBus.Notificaciones.Completado( 'Guardado correctamente' );
            }
            else
            {
                this.Estado = 'ok';
                this.$EventBus.Notificaciones.Error( 'Error al guardar' );
            }
        }

        async Cancelar()
        {
            //this.Iniciar();
            this.Controlador.Vista.Modo = 'resumen';
        }

        public Refresh: boolean = true;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }


    }
